import React, { forwardRef, useImperativeHandle } from "react";
import { useHistory } from "react-router-dom";

import { useSelector } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
  clickNewTenpo,
  clickNewOneVision,
  clickNewTs,
  URL_ENQUIRY,
  URL_Q_A,
  clickNewKeieiShindan,
} from "../Home/Home";
import {
  isOpenRegistPage,
  isOpenStatusConfirmPage,
  isOpenManagerAnalysisPage,
  isOpenTemplatePage,
  getJobCategoryFromCode,
} from "../../apis/privilege";
import { selectUser } from "../../../src/features/userSlice";
import { auth } from "../../firebase";
import MenuIcon from "@material-ui/icons/Menu";
import { Grid, Typography } from "@material-ui/core";
import { userLogging } from "../../apis/userLog";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

type Anchor = "left";
const imgDir = `${window.location.origin}/image/icons/`;

const tenpoNewItem = {
  title: "新規登録",
  id: "tenpo-check",
  icon: "new_icon.png",
};
const tenpoSearchItem = {
  title: "データ検索",
  id: "tenpo-check-search",
  icon: "search_icon.png",
};
const tenpoStatusConfirmItem = {
  title: "提出状況確認",
  id: "tenpo-check-filing-status-confirm",
  icon: "confirm_icon.png",
};
const tenpoManagerAnalysisItem = {
  title: "管理者分析",
  id: "tenpo-check-manager-analysis",
  icon: "analysis_icon.png",
};
const tenpoTemplateItem = {
  title: "テンプレート",
  id: "tenpo-check-template",
  icon: "template_icon.png",
};

const onevisionNewItem = {
  title: "新規登録",
  id: "one-vision",
  icon: "new_icon.png",
};
const onevisionSearchItem = {
  title: "データ検索",
  id: "one-vision-search",
  icon: "search_icon.png",
};
const onevisionStatusConfirmItem = {
  title: "提出状況確認",
  id: "one-vision-filing-status-confirm",
  icon: "confirm_icon.png",
};
const onevisionManagerAnalysisItem = {
  title: "管理者分析",
  id: "one-vision-manager-analysis",
  icon: "analysis_icon.png",
};
const onevisionSearchOldItem = {
  title: "(過去分)データ検索",
  id: "one-vision-search-old",
  icon: "search_icon.png",
};
const onevisionManagerAnalysisOldItem = {
  title: "(過去分)管理者分析",
  id: "one-vision-manager-analysis-old",
  icon: "analysis_icon.png",
};
const tsNewItem = {
  title: "新規登録",
  id: "ts-check",
  icon: "new_icon.png",
};
const tsSearchItem = {
  title: "データ検索",
  id: "ts-check-search",
  icon: "search_icon.png",
};
const tsStatusConfirmItem = {
  title: "提出状況確認",
  id: "ts-check-filing-status-confirm",
  icon: "confirm_icon.png",
};
const tsManagerAnalysisItem = {
  title: "管理者分析",
  id: "ts-check-manager-analysis",
  icon: "analysis_icon.png",
};
const tsSearchOldItem = {
  title: "(過去分)データ検索",
  id: "ts-check-search-old",
  icon: "search_icon.png",
};
const tsManagerAnalysisOldItem = {
  title: "(過去分)管理者分析",
  id: "ts-check-manager-analysis-old",
  icon: "analysis_icon.png",
};

const keieiShindanNewItem = {
  title: "新規登録",
  id: "keiei-shindan",
  icon: "new_icon.png",
};
const keieiShindanSearchItem = {
  title: "データ検索",
  id: "keiei-shindan-search",
  icon: "search_icon.png",
};
const keieiShindanStatusConfirmItem = {
  title: "提出状況確認",
  id: "keiei-shindan-filing-status-confirm",
  icon: "confirm_icon.png",
};
const keieiShindanManagerAnalysisItem = {
  title: "管理者分析",
  id: "keiei-shindan-manager-analysis",
  icon: "analysis_icon.png",
};
const keieiShindanSearchOldItem = {
  title: "(過去分)データ検索",
  id: "keiei-shindan-search-old",
  icon: "search_icon.png",
};
const keieiShindanManagerAnalysisOldItem = {
  title: "(過去分)管理者分析",
  id: "keiei-shindan-manager-analysis-old",
  icon: "analysis_icon.png",
};

let tenpoCheckItems = [
  tenpoNewItem,
  tenpoSearchItem,
  tenpoStatusConfirmItem,
  // tenpoManagerAnalysisItem,
];

let oneVisionItems = [
  onevisionNewItem,
  onevisionSearchItem,
  onevisionStatusConfirmItem,
  onevisionSearchOldItem,
  // onevisionManagerAnalysisItem,
];

let tsCheckItems = [
  tsNewItem,
  tsSearchItem,
  tsStatusConfirmItem,
  // tsManagerAnalysisItem,
];

let keieiShindanCheckItems = [
  keieiShindanNewItem,
  keieiShindanSearchItem,
  keieiShindanStatusConfirmItem,
  // keieiShindanManagerAnalysisItem,
];

export interface SwipTempDrawerHandles {
  openDrawer(): void;
}

export const SwipeableTemporaryDrawer = forwardRef<SwipTempDrawerHandles>(
  (props, ref) => {
    const classes = useStyles();
    const history = useHistory();
    const [state, setState] = React.useState({
      left: false,
    });
    const user: any = useSelector(selectUser);
    tenpoCheckItems = [];
    oneVisionItems = [];
    tsCheckItems = [];
    keieiShindanCheckItems = [];
    // 新規登録
    if (isOpenRegistPage(user)) {
      tenpoCheckItems.push(tenpoNewItem);
      oneVisionItems.push(onevisionNewItem);
      tsCheckItems.push(tsNewItem);
      keieiShindanCheckItems.push(keieiShindanNewItem);
    }
    // 検索
    tenpoCheckItems.push(tenpoSearchItem);
    oneVisionItems.push(onevisionSearchItem);
    tsCheckItems.push(tsSearchItem);
    keieiShindanCheckItems.push(keieiShindanSearchItem);
    // 提出状況確認
    if (isOpenStatusConfirmPage(user)) {
      tenpoCheckItems.push(tenpoStatusConfirmItem);
      oneVisionItems.push(onevisionStatusConfirmItem);
      tsCheckItems.push(tsStatusConfirmItem);
      keieiShindanCheckItems.push(keieiShindanStatusConfirmItem);
    }
    // 管理者分析
    if (isOpenManagerAnalysisPage(user)) {
      tenpoCheckItems.push(tenpoManagerAnalysisItem);
      oneVisionItems.push(onevisionManagerAnalysisItem);
      tsCheckItems.push(tsManagerAnalysisItem);
      keieiShindanCheckItems.push(keieiShindanManagerAnalysisItem);
    }
    oneVisionItems.push(onevisionSearchOldItem);
    if (isOpenManagerAnalysisPage(user)) {
      oneVisionItems.push(onevisionManagerAnalysisOldItem);
    }
    tsCheckItems.push(tsSearchOldItem);
    if (isOpenManagerAnalysisPage(user)) {
      tsCheckItems.push(tsManagerAnalysisOldItem);
    }
    keieiShindanCheckItems.push(keieiShindanSearchOldItem);
    if (isOpenManagerAnalysisPage(user)) {
      keieiShindanCheckItems.push(keieiShindanManagerAnalysisOldItem);
    }
    // テンプレート
    if (isOpenTemplatePage(user)) {
      tenpoCheckItems.push(tenpoTemplateItem);
    }

    useImperativeHandle(ref, () => ({
      openDrawer() {
        setState({ ...state, left: true });
      },
    }));
    const signOut = () => {
      auth
        .signOut()
        .then(() => {})
        .catch((error) => {
          console.log(`logout error (${error})`);
        });
    };

    const toggleDrawer =
      (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event &&
          event.type === "keydown" &&
          ((event as React.KeyboardEvent).key === "Tab" ||
            (event as React.KeyboardEvent).key === "Shift")
        ) {
          return;
        }
        setState({ ...state, [anchor]: open });
      };
    const list = (anchor: Anchor) => (
      <div
        className={clsx(classes.list)}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <List>
          <ListItem>
            <ListItemIcon>
              <img
                src={imgDir + "tenpo_check_icon.png"}
                alt=""
                style={{
                  backgroundColor: "black",
                  height: "20px",
                  marginRight: "10px",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary={"店舗確認表"}
              primaryTypographyProps={{
                variant: "inherit",
              }}
            />
          </ListItem>
          {tenpoCheckItems.map((item) => (
            <ListItem
              button
              key={item.id}
              onClick={() => {
                if (item.id === "tenpo-check") {
                  clickNewTenpo();
                }
                history.push(item.id);
                userLogging("店舗確認表", "サイドメニュー", item.title);
              }}
            >
              <ListItemIcon>
                <img
                  src={imgDir + item.icon}
                  alt=""
                  style={{ height: "20px", paddingRight: "10px" }}
                />
              </ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          <ListItem>
            <ListItemIcon>
              <img
                src={imgDir + "one_vision_icon.png"}
                alt=""
                style={{
                  backgroundColor: "black",
                  height: "20px",
                  marginRight: "10px",
                }}
              />
            </ListItemIcon>
            <ListItemText primary={"ONEVISION"} />
          </ListItem>
          {oneVisionItems.map((item) => (
            <ListItem
              button
              key={item.id}
              onClick={() => {
                if (item.id === "one-vision") {
                  clickNewOneVision();
                }
                history.push(item.id);
                userLogging("OneVision", "サイドメニュー", item.title);
              }}
            >
              <ListItemIcon>
                <img
                  src={imgDir + item.icon}
                  alt=""
                  style={{ height: "20px", paddingRight: "10px" }}
                />
              </ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}

          <Divider />
          <ListItem>
            <ListItemIcon>
              <img
                src={imgDir + "ts_check_icon.png"}
                alt=""
                style={{
                  backgroundColor: "black",
                  height: "20px",
                  marginRight: "10px",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary={"店舗衛生点検表"}
              primaryTypographyProps={{
                variant: "inherit",
              }}
            />
          </ListItem>
          {tsCheckItems.map((item) => (
            <ListItem
              button
              key={item.id}
              onClick={() => {
                if (item.id === "ts-check") {
                  clickNewTs();
                }
                history.push(item.id);
                userLogging("店舗衛生点検表", "サイドメニュー", item.title);
              }}
            >
              <ListItemIcon>
                <img
                  src={imgDir + item.icon}
                  alt=""
                  style={{ height: "20px", paddingRight: "10px" }}
                />
              </ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}

          <Divider />
          <ListItem>
            <ListItemIcon>
              <img
                src={imgDir + "ts_check_icon.png"}
                alt=""
                style={{
                  backgroundColor: "black",
                  height: "20px",
                  marginRight: "10px",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary={"店舗経営診断"}
              primaryTypographyProps={{
                variant: "inherit",
              }}
            />
          </ListItem>
          {keieiShindanCheckItems.map((item) => (
            <ListItem
              button
              key={item.id}
              onClick={() => {
                if (item.id === "keiei-shindan") {
                  clickNewKeieiShindan();
                }
                history.push(item.id);
                userLogging("店舗経営診断", "サイドメニュー", item.title);
              }}
            >
              <ListItemIcon>
                <img
                  src={imgDir + item.icon}
                  alt=""
                  style={{ height: "20px", paddingRight: "10px" }}
                />
              </ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}

          <Divider />
          <ListItem
            button
            key="manual"
            onClick={() => {
              window.open(URL_Q_A, "_blank");
              userLogging("その他", "サイドメニュー", "Q＆A");
            }}
          >
            <ListItemIcon>
              <img
                // src={imgDir + "logout_icon.png"}
                alt=""
                style={{ height: "20px", paddingRight: "10px" }}
              />
            </ListItemIcon>
            <ListItemText primary={"Q＆A"} />
          </ListItem>
          <ListItem
            button
            key="manual"
            onClick={() => {
              window.open(URL_ENQUIRY, "_blank");
              userLogging("その他", "サイドメニュー", "マニュアル・問い合わせ");
            }}
          >
            <ListItemIcon>
              <img
                // src={imgDir + "logout_icon.png"}
                alt=""
                style={{ height: "20px", paddingRight: "10px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography style={{ fontSize: "13px" }}>
                  マニュアル・問い合わせ
                </Typography>
              }
            />
          </ListItem>

          <Divider />
          {process.env.REACT_APP_MODE === "develop" ||
           process.env.REACT_APP_MODE === "test-tenpo-check" ? (
            <>
            <ListItem
              button
              key="logout"
              onClick={() => {
                signOut();
                history.push("login");
                userLogging("共通", "サイドメニュー", "ログアウト");
              }}
            >
              <ListItemIcon>
                <img
                  src={imgDir + "logout_icon.png"}
                  alt=""
                  style={{ height: "20px", paddingRight: "10px" }}
                />
              </ListItemIcon>
              <ListItemText primary={"ログアウト"} />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={user.mailAddress}
                primaryTypographyProps={{
                  variant: "inherit",
                }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={user.uid}
                primaryTypographyProps={{
                  variant: "inherit",
                }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={getJobCategoryFromCode(user)}
                primaryTypographyProps={{
                  variant: "inherit",
                }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={JSON.stringify(user.zoCode)}
                primaryTypographyProps={{
                  variant: "inherit",
                }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={JSON.stringify(user.doCode)}
                primaryTypographyProps={{
                  variant: "inherit",
                }}
              />
          </ListItem>
          </>
        ) : (
            ""
          )}
        </List>
      </div>
    );

    return (
      <React.Fragment>
        <Grid style={{ display: "flex" }}>
          <Button onClick={toggleDrawer("left", true)}>
            <MenuIcon></MenuIcon>
          </Button>
          <img
            src={`${window.location.origin}/image/sejlogo.png`}
            alt="SEJアイコン"
            style={{ height: "7vh" }}
          />
        </Grid>
        <SwipeableDrawer
          anchor={"left"}
          open={state["left"]}
          onClose={toggleDrawer("left", false)}
          onOpen={toggleDrawer("left", true)}
        >
          {list("left")}
        </SwipeableDrawer>
      </React.Fragment>
    );
  }
);
